import { Component, OnInit } from '@angular/core';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { InteractionStatus } from '@azure/msal-browser';
import { Subject, filter, forkJoin, takeUntil } from 'rxjs';
import { AccountRolesService } from 'src/app/shared/services/account-roles.service';
import { DataErrorsService } from 'src/app/shared/services/data-errors.service';

@Component({
  standalone: false,
  selector: 'app-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss'],
})
export class SidenavComponent implements OnInit  {

  private readonly _destroying$ = new Subject<void>();
  unresolvedCount = 0;
  menuItemsVisibility: {
    dataErrors: boolean,
    fuelContracts: boolean,
    crco: boolean,
    sapExport: boolean,
    volumeCalculator: boolean,
    fuelTenders: boolean,
    fuelApp: boolean,
    dictionary: boolean,
    reports: boolean,
  } = {
    dataErrors: false,
    fuelContracts: false,
    crco: false,
    sapExport: false,
    volumeCalculator: false,
    fuelTenders: false,
    fuelApp: false,
    dictionary: false,
    reports: false
  };

  constructor(
    private dataErrorsService: DataErrorsService,
    private msalBroadcastService: MsalBroadcastService,
    private authService: MsalService,
    private accountRolesServie: AccountRolesService) {
    forkJoin({
      unresolved: this.dataErrorsService.getUnresolvedCount(),
      doubleUnresolved: this.dataErrorsService.getDoubleUnresolvedCount(),
      differenceRefuelingQuantityUnresolved: this.dataErrorsService.getDifferenceUnresolvedCount(),
      sapDataUnresolved: this.dataErrorsService.getSapDataUnresolvedCount(),
    }).subscribe(({ unresolved, doubleUnresolved, differenceRefuelingQuantityUnresolved, sapDataUnresolved }) => {
      if (unresolved && doubleUnresolved && differenceRefuelingQuantityUnresolved && sapDataUnresolved) {
        this.unresolvedCount = unresolved.unresolvedCount + doubleUnresolved.unresolvedCount + differenceRefuelingQuantityUnresolved.unresolvedCount + sapDataUnresolved.unresolvedCount;
      }
    });
  }

  ngOnInit(): void {
    this.msalBroadcastService.inProgress$
      .pipe(
        filter(
          (status: InteractionStatus) => status === InteractionStatus.None
        ),
        takeUntil(this._destroying$)
      )
      .subscribe({
        next: () => {
          this.setMenuItemsVisibility();
        },
        error: (err) => {
          console.error(err);
        }
    });
  }

  ngOnDestroy() {
    this._destroying$.next();
    this._destroying$.complete();
  }

  setMenuItemsVisibility(): void {
    const activeAccount = this.authService.instance.getActiveAccount();
    if (activeAccount) {
      var userRoles = this.accountRolesServie.getAssignedRoles(activeAccount);
      this.menuItemsVisibility.crco = userRoles.IsInNewFcaAdmin;
      this.menuItemsVisibility.dataErrors = userRoles.IsInNewFcaAdmin
        || userRoles.IsInNewFcaAnalysisTeam;
      this.menuItemsVisibility.dictionary = userRoles.IsInNewFcaAdmin;
      this.menuItemsVisibility.fuelContracts = userRoles.IsInNewFcaAdmin
        || userRoles.IsInNewFcaAnalysisTeam
        || userRoles.IsInNewFcaManagementTeam
        || userRoles.IsInNewFcaSettlementTeam;
      this.menuItemsVisibility.fuelTenders = userRoles.IsInNewFcaAdmin
        || userRoles.IsInNewFcaManagementTeam
        || userRoles.IsInNewFcaSettlementTeam;
      this.menuItemsVisibility.fuelApp = userRoles.IsInNewFcaAdmin;
      this.menuItemsVisibility.reports = userRoles.IsInNewFcaAdmin
        || userRoles.IsInNewFcaAnalysisTeam
        || userRoles.IsInNewFcaManagementTeam;
      this.menuItemsVisibility.sapExport = userRoles.IsInNewFcaAdmin
        || userRoles.IsInNewFcaSettlementTeam;
      this.menuItemsVisibility.volumeCalculator = userRoles.IsInNewFcaAdmin
        || userRoles.IsInNewFcaAnalysisTeam
        || userRoles.IsInNewFcaManagementTeam
        || userRoles.IsInNewFcaSettlementTeam;
    }
  }
}
